<template>
  <van-tabbar 
  v-model="active" 
  :inactive-color="$store.state.grey_7" 
  z-index="999"
  :active-color="$store.state.black" 
  :placeholder="true"
  :before-change="beforeChange"
  :safe-area-inset-bottom="false">
    <van-tabbar-item v-for="(item,index) in tabbars" :key="index" @click="gourl(item)" >
        <b style="font-size: 0.22rem;line-height: 0.28rem;">{{item.title}}</b>
        <template #icon="props">
            <van-icon :name="require('../assets/draft/tabbar/icon_'+(props.active ? index+'_on' : index)+'.png')" size="0.4rem"/>
        </template>
    </van-tabbar-item>
  </van-tabbar>
</template>
<script>
	import { Tabbar, TabbarItem,Dialog,image,icon,Toast} from "vant";
    import Qs from 'qs';
	export default {
		components: {
            [Tabbar.name]: Tabbar,
			[TabbarItem.name]: TabbarItem,
			[image.name]:image,
            [icon.name]:icon,
            [Toast.name]:Toast
		},
	  data() {
			return {
				active: 0,
                oldactive:'',
				tabbars: [
					{
						name: "homeIndex",
						title: "首页",
					},
                    {
                    	name: "addDraft",
                    	title: "上传",
                    },
					{
						name: "myIndex",
						title: "个人",
					}
				],
			}
		},
		methods: {
            beforeChange(index){
                this.oldactive=index;
            },
			gourl(item){
				if(item.name=="addDraft"){
                    if(this.$store.state.loginstatus==1){
                        this.$router.push({
                            path: item.name,
                            query:{
                                shopid:this.$route.query.shopid,
                                shopname:this.$route.query.shopname,
                                orgid:this.$route.query.orgid,
                                manageuid:this.$route.query.manageuid,
                                manageuname:this.$route.query.manageuname,
                            }
                        });
                    }else{
                        if(!this.$islogin()){
                            this.active=this.oldactive;
                            this.$router.push({
                                path: 'login',
                                query:{
                                    id:this.$route.query.tid,
                                    shopid:this.$route.query.shopid,
                                    shopname:this.$route.query.shopname,
                                    orgid:this.$route.query.orgid,
                                    manageuid:this.$route.query.manageuid,
                                    manageuname:this.$route.query.manageuname,
                                    }
                            });
                        }
                    }
                    // this.axios.post(this.ajaxUrl('bdp',"d=wxapi&c=se_user_profile&m=user_byid"), Qs.stringify({
                    // })).then((res) => {
                    //     if(res.data.status_code == 200){
                    //         let obj=res.data.data
                    //         if(obj.userstatus!=1&&obj.userstatus!=2&&obj.userstatus!=3){
                    //             Dialog.confirm({
                    //               title: '温馨提示',
                    //               message: '实名认证后方可开通银票商票业务',
                    //               width:"6.4rem",
                    //               confirmButtonText:'实名认证'
                    //             })
                    //             .then(() => {
                    //                 this.$router.push({
                    //                     path: 'attestationone',
                    //                 });
                    //             })
                    //             .catch(() => {
                    //             // on cancel
                    //             });
                    //         }else{
                    //             this.$router.push({
                    //                 path: item.name,
                    //             });
                    //         }
                    //     }else if(res.data.status_code == 201){
                    //         if(!this.$islogin()){
                    //             this.active=this.oldactive;
                    //             this.$router.push({
                    //                 path: 'login',
                    //                 query:{
                    //                     id:this.$route.query.tid
                    //                 }
                    //             });
                    //         }
                    //     }
                    // })
                }else{
                    this.$router.push({
                    	path: item.name,
                        query:{
                            tid:this.$route.query.tid,
                            shopid:this.$route.query.shopid,
                            shopname:this.$route.query.shopname,
                            orgid:this.$route.query.orgid,
                            manageuid:this.$route.query.manageuid,
                            manageuname:this.$route.query.manageuname,                     }
                    });
                }
					
			},
		},
  //通过路由跳转判断选中的样式
		created() {
			if (this.$route.name == "homeIndex") {
				this.active = 0;
			} else if (this.$route.name == "addDraft") {
				this.active = 1;
			}else if (this.$route.name == "myIndex") {
				this.active = 2;
			}
			
		},
		watch:{
			'$route' (val,oldval) {
				if (this.$route.name == "homeIndex") {
					this.active = 0;
				} else if (this.$route.name == "addDraft") {
					this.active = 1;
				}else if (this.$route.name == "myIndex") {
					this.active = 2;
				}
			}
		}
	}
</script>
<style scoped lang="less">
@import '../style/css/variable.less';
::v-deep{
    .van-tabbar{
    	height:0.98rem;
    	line-height: 0.98rem;
    	font-size: 0.22rem;
    	.van-tabbar-item__icon{
    		margin:0;
    	}
    }
}

</style>